module.exports = __webpack_public_path__ + "img/bj-acorn.be540343.gif";